import { Stepper } from "../../../components/Stepper"
import { BuyData } from "../../../types/steps/buy"
import { Pay, Seats } from "./screens"
import CancelStatus from "./screens/CancelStatus"
import PayStatus from "./screens/PayStatus"
import Pushkin from "./screens/Pushkin"
import Sbp from "./screens/Sbp"
import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { isBuyRouteState } from "../../../types/steps/buy"
import Loader from "../../../components/Loader"
import { unpaidOrderStore } from "../../../store/unpaidOrderStore"
import { isUnpaid } from "../../../features/tickets/ticketUtils"
import { hrefForCurrentCinema } from "../../../lib/cinemaSlugs"

export default function Buy() {
    const location = useLocation()
    const navigate = useNavigate()
    const buyState = isBuyRouteState(location.state) ? location.state : null
    const unpaidTicket = unpaidOrderStore(state => state.unpaidTicket)
    const blockedByUnpaid = !!unpaidTicket && isUnpaid(unpaidTicket)

    useEffect(() => {
        if (blockedByUnpaid) {
            unpaidOrderStore.getState().openNotice()
            const background = (location.state as { backgroundLocation?: { pathname?: string } } | null)
                ?.backgroundLocation
            navigate(background?.pathname ? background : hrefForCurrentCinema("/afisha"), { replace: true })
            return
        }
        if (!buyState) {
            navigate(hrefForCurrentCinema("/afisha"), { replace: true })
        }
    }, [blockedByUnpaid, buyState, location.state, navigate])

    if (blockedByUnpaid) return null
    if (!buyState) return <Loader />

    const steps = [
        { id: "seats", title: "Выбрать места", component: Seats },
        { id: "pay", title: "Оплатить", component: Pay },
        { id: "sbp", title: "СБП", component: Sbp },
        { id: "pushkin", title: "Пушкинская карта", component: Pushkin },
        { id: "payStatus", title: "Статус оплаты", component: PayStatus },
        { id: "cancelStatus", title: "Отмена билета", component: CancelStatus }
    ]

    return <Stepper<BuyData> steps={steps} overlay sheet />
}
